import type { ProposalResult } from "@artemis-group/aiw-contracts";

/** The backbone's answer, in words. */
export interface Outcome { tone: "ok" | "wait" | "no"; text: string }

export function outcomeWords(r: ProposalResult, doneWord = "Done"): Outcome {
  switch (r.status) {
    case "executed": return { tone: "ok", text: doneWord };
    case "pending": return { tone: "wait", text: "EmmA will confirm" };
    default: return { tone: "no", text: `Not allowed · ${r.reason}` };
  }
}

/** A proposal that THREW, in words (25 Oct 2026). The backbone answers a refused or failed command with
 *  HTTP 403 and its answer in the body (`{status:"denied", reason}`), and the API client throws on any
 *  non-2xx — so "permission denied for table products" reached Price my floor as "Could not reach the
 *  backbone". That wording is now kept for a request that got no answer at all (a network failure). */
export function outcomeOfError(e: unknown): Outcome {
  const answered = e instanceof Error && "status" in e && typeof (e as { status: unknown }).status === "number";
  if (!answered) return { tone: "no", text: `Could not reach the backbone · ${e instanceof Error ? e.message : String(e)}` };
  const body = (e as { body?: unknown }).body as { status?: unknown; action_id?: unknown; reason?: unknown } | null | undefined;
  if (body && typeof body === "object" && body.status === "denied" && typeof body.reason === "string")
    return outcomeWords({ status: "denied", action_id: String(body.action_id ?? ""), reason: body.reason });
  return { tone: "no", text: `Not done · ${(e as Error).message}` };
}
